import type { Permission } from "$lib/data/type/permission"

export const PERMISSIONS: Permission[] = [
  {
    label: "GPS",
    name: "geolocation",
    is_granted: false
  },
  {
    label: "Kamera",
    name: "camera",
    is_granted: false
  },
]
